module.exports = {"trip":"トリップ","accommodation":"宿泊"}